export const ENV_CONFIG = {
  firebase: {
    apiKey: "AIzaSyCHO13d957YC--Ls4N_D-B9RINs14AL7Ao",
    authDomain: "ga-menoage.firebaseapp.com",
    projectId: "ga-menoage",
    storageBucket: "ga-menoage.appspot.com",
    messagingSenderId: "849426402174",
    appId: "1:849426402174:web:31dbe9aebd5c0e7228812f",
    measurementId: "G-VKTL0MLZZN"
  }
}
